import keys from 'lodash/keys';
import get from 'lodash/get';

export default {
    bind(el, binding, vnode) {
        const event = keys(binding.modifiers)[0];
        const action = binding.expression;
        const title = get(vnode, 'data.attrs.confirmation-title', 'Are you sure?');
        const message = get(vnode, 'data.attrs.confirmation-message', false);
        let options = message ? [title, message] : title;

        el.addEventListener(event, function () {
            swalc(options, confirm => {
                if (confirm) {
                }
            });
        });
    },
    unbind: function (el, binding, vnode) {
        const event = keys(binding.modifiers)[0];
        el.removeEventListener(event);
    },
};
